// react
import React from 'react';
import { useDispatch } from 'react-redux';
import {
    Link,
    matchPath,
    Redirect,
    Switch,
    Route,
    useHistory,
} from 'react-router-dom';

// application
import PageHeader from '../shared/PageHeader';
import { resetAuth } from '../../store/auth/authActions';

// pages
import AccountPageAddresses from './AccountPageAddresses';
import AccountPageDashboard from './AccountPageDashboard';
import AccountPageEditAddress from './AccountPageEditAddress';
import AccountPageOrderDetails from './AccountPageOrderDetails';
import AccountPageOrders from './AccountPageOrders';
import AccountPagePassword from './AccountPagePassword';
import AccountPageProfile from './AccountPageProfile';

export default function AccountLayout(props) {
    const { match, location } = props;
    const dispatch = useDispatch();
    const history = useHistory();

    const searchParams = new URLSearchParams(location.search);
    const isAddressRoute = location.pathname.includes('/addresses');
    const isFromCheckout = isAddressRoute && (
        searchParams.get('from') === 'checkout' ||
        sessionStorage.getItem('EDIT_ADDRESS_FROM') === 'checkout'
    );

    const isOrdersPage = location.pathname.startsWith(`${match.url}/orders`);

    const breadcrumb = isFromCheckout ? [
        { title: 'Home', url: '/' },
        { title: 'Keranjang', url: '/cart' },
        { title: 'Checkout', url: '/shop/checkout' },
        { title: 'Alamat', url: '' },
    ] : isOrdersPage ? [
        { title: 'Home', url: '/' },
        { title: 'Transaksi', url: `${match.url}/orders` },
    ] : [
        { title: 'Home', url: '/' },
        { title: 'Akun Saya', url: '/account' },
    ];

    const navLinks = [
        { title: 'Profil', url: 'dashboard', icon: 'fas fa-user-circle' },
        { title: 'Pemesanan Produk', url: 'orders', icon: 'fas fa-shopping-bag' },
        { title: 'Alamat', url: 'addresses', icon: 'fas fa-map-marked-alt' },
        { title: 'Password', url: 'password', icon: 'fas fa-shield-alt' },
    ];

    const handleLogout = () => {
        dispatch(resetAuth());
        history.push('/account/login');
    };

    return (
        <div className="block account-page-block">
            <PageHeader breadcrumb={breadcrumb} />

            <div className="container hokky-cart-container">
                    <div className="row">
                        {/* Sidebar Navigation - on mobile hidden when on Transaksi/orders page */}
                        <div className="col-12 col-lg-3 account-sidebar-col d-none d-lg-block">
                            <div className="account-nav-modern">
                                <ul className="account-nav__menu">

                                    {navLinks.map((link) => {
                                        const url = `${match.url}/${link.url}`;
                                        const isActive = matchPath(location.pathname, { path: url, exact: true });
                                        // In mobile account view, hide "Pemesanan Produk" tab (dedicated to bottom nav Transaksi)
                                        const isOrdersLink = link.url === 'orders';
                                        return (
                                            <li key={link.url} className={`account-nav__item ${isOrdersLink ? 'd-none d-lg-block' : ''}`}>
                                                <Link to={url} className={`account-nav__link ${isActive ? 'active' : ''}`}>
                                                    <div className="link-left">
                                                        <span className="link-icon-box">
                                                            <i className={`link-icon ${link.icon}`} />
                                                        </span>
                                                        <span className="link-title">{link.title}</span>
                                                    </div>
                                                    <i className="chevron-icon fas fa-chevron-right" />
                                                </Link>
                                            </li>
                                        );
                                    })}
                                    <div className="account-nav__divider" />
                                    <li className="account-nav__item">
                                        <button
                                            type="button"
                                            className="account-nav__logout-btn"
                                            onClick={handleLogout}
                                        >
                                            <span className="link-icon-box logout-icon-box">
                                                <i className="fas fa-sign-out-alt" />
                                            </span>
                                            <span className="link-title">Keluar Akun</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Main Content Area */}
                        <div className={`col-12 col-lg-9 ${isOrdersPage ? 'mt-0' : 'mt-1 mt-lg-0'}`}>
                            <div key={location.pathname} className="account-page-transition">
                                <Switch>
                                    <Redirect exact from={match.path} to={`${match.path}/dashboard`} />
                                    <Route exact path={`${match.path}/dashboard`} component={AccountPageDashboard} />
                                    <Route exact path={`${match.path}/profile`} component={AccountPageProfile} />
                                    <Route exact path={`${match.path}/orders`} component={AccountPageOrders} />
                                    <Route exact path={`${match.path}/orders/:OrderId`} component={AccountPageOrderDetails} />
                                    <Route exact path={`${match.path}/addresses`} component={AccountPageAddresses} />
                                    <Route exact path={`${match.path}/addresses/:addressId`} component={AccountPageEditAddress} />
                                    <Route exact path={`${match.path}/password`} component={AccountPagePassword} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}
